import { SELECT_MEDIA, DESELECT_MEDIA, SELECT_ALL_MEDIA, DESELECT_ALL_MEDIA } from '../constants/actionTypes';
import { downloadUrl } from '../helpers';

export const selectMedia = (scene, mediaItem) => ({
    type: SELECT_MEDIA,
    scene: scene,
    sceneMediaID: mediaItem.sceneMediaID,
    url:  downloadUrl(mediaItem.sourceRepository, mediaItem.sourcePath)
});

export const deselectMedia = (scene, mediaItem) => ({
    type: DESELECT_MEDIA,
    scene: scene, 
    sceneMediaID: mediaItem.sceneMediaID, 
    url: downloadUrl(mediaItem.sourceRepository, mediaItem.sourcePath)
});

export const selectAllMedia = (scene, mediaItems) => ({
    type: SELECT_ALL_MEDIA,
    scene: scene,
    mediaItems: mediaItems,
    urls: mediaItems.map(m => downloadUrl(m.sourceRepository, m.sourcePath))
});

export const deselectAllMedia = (scene, mediaItems) => ({
    type: DESELECT_ALL_MEDIA,
    scene: scene,
    mediaItems: mediaItems,
    urls: mediaItems.map(m => downloadUrl(m.sourceRepository, m.sourcePath)) 
});



// WEBPACK FOOTER //
// ./src/actions/selectMedia.js